import { Sprite } from "pixi.js"
import asteroidpng from "./asteroid.png"

export const createAsteroid = (isReal) => {
  let asteroid = Sprite.from(asteroidpng)
  asteroid.anchor.set(0.5, 0.5)
  asteroid.y = -30
  asteroid.name = "ast"
  let randX = isReal ? Math.random() * 120 + 100 : Math.random() * 250 + 35

  asteroid.x = randX

  let randScale = Math.random() * 0.6 + 0.4
  asteroid.scale.set(randScale, randScale)
  asteroid.anchor.set(0.5, 0.5)

  asteroid.asteroidDistance = 0
  asteroid.moved = false
  asteroid.isReal = isReal
  asteroid.randRotation = Math.random() / 10 - 0.05

  return [asteroid, randX]
}
